const caTimeZones = [
  'Canada/Atlantic',
  'Canada/Central',
  'Canada/Eastern',
  'Canada/Mountain',
  'Canada/Newfoundland',
  'Canada/Pacific',
  'Canada/Saskatchewan',
  'Canada/Yukon',
].map((value) => ({
  label: value,
  value: value,
}));

export default caTimeZones;
